/**
 * @desc PDA-sku拣货点击找不到
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.PickDetailBoxRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/pickMaster/notFound`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
